import type { SeoPayload } from '@/modules/common/seo/seo'

let metadataPromise: Promise<Record<string, SeoPayload>> | null = null

async function loadProductMetadata(): Promise<Record<string, SeoPayload>> {
  const response = await fetch('/seo/product-metadata.json', {
    headers: {
      Accept: 'application/json',
    },
  })

  if (!response.ok) {
    throw new Error(`Failed to load product SEO metadata: ${response.status}`)
  }

  const payload = await response.json()
  return typeof payload === 'object' && payload !== null
    ? (payload as Record<string, SeoPayload>)
    : {}
}

export async function getGeneratedProductSeoMetadata(
  productId: string | number,
): Promise<SeoPayload | null> {
  if (metadataPromise === null) {
    metadataPromise = loadProductMetadata().catch((error) => {
      metadataPromise = null
      throw error
    })
  }

  const metadata = await metadataPromise
  const key = String(productId)

  return metadata[key] ?? null
}
